import { jsx as L, jsxs as t } from "react/jsx-runtime";
import "react";
var F = (l) => /* @__PURE__ */ t("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-856 -848)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0.000244141H0V19.9999H20V0.000244141Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V6.66655H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ L("path", {
      d: "M8.33008 12.5362H11.6692V11.117L11.0014 11.4509L9.99965 10.4492L8.99789 11.4509L8.33008 11.117V12.5362Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.42 10.8666L6.57543 11.3449H7.07828L6.67148 11.6405L6.82688 12.1188L6.42 11.8231L6.01316 12.1188L6.16856 11.6405L5.76172 11.3449H6.26461L6.42 10.8666Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.90246 9.19702L7.05785 9.6753H7.56074L7.15387 9.97089L7.30926 10.4492L6.90246 10.1536L6.49559 10.4492L6.65098 9.97089L6.24414 9.6753H6.74703L6.90246 9.19702Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M8.27941 7.94495L8.43481 8.42319H8.93773L8.53086 8.71882L8.68625 9.1971L8.27941 8.90151L7.87254 9.1971L8.02793 8.71882L7.62109 8.42319H8.12398L8.27941 7.94495Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.5802 10.8666L13.4248 11.3449H12.9219L13.3287 11.6405L13.1734 12.1188L13.5802 11.8231L13.9871 12.1188L13.8317 11.6405L14.2385 11.3449H13.7356L13.5802 10.8666Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.0977 9.19702L12.9423 9.6753H12.4395L12.8463 9.97089L12.6909 10.4492L13.0977 10.1536L13.5046 10.4492L13.3492 9.97089L13.7561 9.6753H13.2532L13.0977 9.19702Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.7208 7.94495L11.5654 8.42319H11.0625L11.4694 8.71882L11.314 9.1971L11.7208 8.90151L12.1277 9.1971L11.9723 8.71882L12.3791 8.42319H11.8763L11.7208 7.94495Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M10.0001 7.31885L10.1555 7.79713H10.6584L10.2516 8.09272L10.407 8.571L10.0001 8.27541L9.59324 8.571L9.74867 8.09272L9.3418 7.79713H9.84469L10.0001 7.31885Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  F as default
};
